import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, computed, inject, input } from '@angular/core';
import { Button } from '../button/button.component';
import { Size } from '../common/types';

@Component({
  selector: 'app-file-download',
  templateUrl: './file-download.component.html',
  styleUrls: ['./file-download.component.scss'],
  standalone: true,
  imports: [CommonModule, Button],
})
export class FileDownload {
  readonly http = inject(HttpClient);

  url = input<string>('');
  size = input<Size>('md');
  name = computed(() => this.getFilenameFromUrl(this.url()));

  handleDownload() {
    if (!this.url()) return;

    this.downloadFile(this.url(), this.name());
  }

  async downloadFile(_url: string, name: string) {
    const url = await this.getDownloadUrl(_url);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;

    const filename = _url?.split('/')?.pop() || 'downloaded_file';
    a.download = filename;

    document.body.appendChild(a);
    a.click();
  }

  getFilenameFromUrl(url: string): string {
    if (!url) return '';
    if (!url.includes('/')) return url;
    return url.split('/').pop() ?? '';
  }

  /**
   * @name getDownloadUrl
   * @description 다운로드 URL 가져오기
   * @returns {Promise<string>}
   */
  private async getDownloadUrl(_url: string): Promise<string> {
    try {
      const res = await fetch(_url, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache',
        },
        mode: 'cors',
        referrerPolicy: 'no-referrer-when-downgrade',
      });
      const blob = await res.blob();
      return window.URL.createObjectURL(blob);
    } catch (error) {
      console.error('Error getting download URL:', error);
      return _url;
    }
  }
}
